import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SiteLayout from "@/components/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="section-pad bg-sage-gradient min-h-[60vh] flex items-center" data-testid="not-found-page">
        <div className="max-w-4xl mx-auto text-center">
          <div className="eyebrow">404</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl mt-5 leading-[1.02]">
            Page not <span className="text-[var(--evara-primary)]">found.</span>
          </h1>
          <p className="mt-6 text-lg text-[var(--evara-text-2)] max-w-xl mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Link to="/" className="btn-primary" data-testid="not-found-home-btn">
              Back to Home <ArrowRight size={16} />
            </Link>
            <Link to="/contact" className="btn-secondary" data-testid="not-found-contact-btn">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
